import React from 'react';
import { CASE_REVIEW_STATUS_ACCEPTED } from './CaseConstants';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/accepted' },
  { label: 'Completed', to: '/user/case/accepted' },
];
const AcceptedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.accepted_case_list_title}
          caseReviewStatus={CASE_REVIEW_STATUS_ACCEPTED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default AcceptedCases;
